import { ReactNode } from "react";

import { Tooltip, Typography } from "@mui/material";
import Box from "@mui/material/Box";

import FilterStyles from "@components/FilterControls/FilterStyles";

interface IFilterFieldLabelsProperties {
  label: ReactNode | string;
  subLabel?: ReactNode | string;
  tooltip?: string;
  TooltipEnterDelay?: number;
}

export default function FilterFieldLabel({
  label,
  subLabel,
  tooltip,
  TooltipEnterDelay = 1500,
}: IFilterFieldLabelsProperties) {
  return (
    <Tooltip enterDelay={TooltipEnterDelay} title={tooltip}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Typography sx={FilterStyles.floatingLabel} variant="caption">
          {label}
        </Typography>
        {subLabel && (
          <Typography sx={FilterStyles.description} variant="caption">
            {subLabel}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
}
